"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Card = void 0;
var classnames_1 = __importDefault(require("classnames"));
var react_1 = __importDefault(require("react"));
var DEFAULT_ELEMENT = 'div';
exports.Card = react_1.default.forwardRef(function AOCard(_a, ref) {
    var _b = _a.as, ElementType = _b === void 0 ? DEFAULT_ELEMENT : _b, children = _a.children, className = _a.className, flex = _a.flex, inheritTextStyle = _a.inheritTextStyle, noBorder = _a.noBorder, noPadding = _a.noPadding, raised = _a.raised, square = _a.square, state = _a.state, props = __rest(_a, ["as", "children", "className", "flex", "inheritTextStyle", "noBorder", "noPadding", "raised", "square", "state"]);
    var border = {
        'border-gray-40': !state,
        'border-error': state === 'error',
        'border-attention': state === 'attention',
        'border-success': state === 'success',
        'border-highlight': state === 'highlight',
    };
    var background = {
        'bg-white': !state,
        'bg-error': state === 'error',
        'bg-attention': state === 'attention',
        'bg-success': state === 'success',
        'bg-highlight': state === 'highlight',
    };
    return (react_1.default.createElement(ElementType, __assign({ className: (0, classnames_1.default)('border border-solid text-body', !square && 'rounded', !inheritTextStyle && 'text-body', flex && 'flex flex-col', !noPadding && 'p-4 lg:p-6', noBorder ? 'border-transparent' : border, raised === true && 'shadow-4dp', background, className
        // TODO: opt-in hover effect with 8dp shadow for flat / 12dp for raised
        ), "data-aods": "card" }, props, { ref: ref }), children));
});
exports.default = exports.Card;
//# sourceMappingURL=Card.js.map